// extracted by mini-css-extract-plugin
export var allInsightArticle = "index-module--allInsightArticle--Qxl4u";
export var articleCard = "index-module--articleCard--05rp9";
export var articleDescription = "index-module--article-description--46Jvj";
export var articleItem = "index-module--articleItem--l7Y7n";
export var articles = "index-module--articles--c6T+V";
export var content = "index-module--content--5vP4P";
export var image = "index-module--image---iJrG";
export var moreButton = "index-module--moreButton--nG67a";